import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkSipSubscribed, handleLogout } from '../../../../services/helperFunctions';
import { ImgLazyload, Avatar } from '../index';
import './navbar.scss';
import SwipeableTemporaryDrawer from '../SideBar/index';
import { UserLoginContext } from '../../../../contexts/LoggedInUserContext';
import { getWalletSummary } from '../../../../redux/actions/WalletSummary';
import DonorIcon from '../../../public/images/donor_icon.png';
import KettoLogo from '../../../public/images/logo-light-bg.svg';

function Navbar() {
  const navigate = useNavigate();
  const { userData, latestOrder } = useContext(UserLoginContext);
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const [isDropDownOpen2, setIsDropDownOpen2] = useState(false);
  const [wallet, setWallet] = useState('');
  const { avtar = null, user_details_id = '', full_name = '' } = userData || {};
  const isSubscribed = checkSipSubscribed(userData?.listsubscriptions);
  const hiddenNav = ['/sipprotect', '/teleconsult', '/gooddeeds'];
  const isVisible = !hiddenNav.includes(document.location.pathname);
  const domain = document.location.href.includes('devsip') || document.location.href.includes('localhost') ? 'https://dev5.ketto.org' : 'https://ketto.org';

  const handleToggleDropdown = () => {
    setIsDropDownOpen(!isDropDownOpen);
    handleWalletLedger();
  };

  const handleToggleDropdownPop = (open) => (event) => {
    setIsDropDownOpen2(open);
    handleWalletLedger();
  };

  const handleToggleDropdownPopClose = () => {
    setIsDropDownOpen2(false);
  };

  const handleUserData = () => {
    const data = JSON.parse(localStorage.getItem('userdata'));
    // setUserData(data);
  };

  const handleOutsideClick = (event) => {
    const exemptedCls = ['down-arrow', 'profile-icon', 'p-2 cursor-poiner dropdown-item'];
    if (event && isDropDownOpen && !exemptedCls.includes(event.target.className)) {
      setIsDropDownOpen(false);
    }
  };

  const handleRedirection = (url, isRoute = false) => {
    if (isRoute) {
      setIsDropDownOpen(false);
      setIsDropDownOpen2(false);
      navigate(url);
    } else {
      window.location.href = url;
    }
  };

  const handleWalletLedger = () => {
    if (userData?.wallet_balance) {
      getWalletSummary(userData?.id, 1).then((res) => {
        setWallet(res.data.data.data);
      });
    }
  };

  return (
    <div className={`navbar ${isVisible ? '' : 'hidden'}`}>
      <div className="navbar-container">
        <div className="logo-container" onClick={() => handleRedirection(domain)}>
          <ImgLazyload
            data-src={KettoLogo}
            src={KettoLogo}
            className="cursor-pointer"
            alt="ketto Logo" />
        </div>
        <div className="profile-container">
          <div className="profile-v2 web-hide" onClick={handleToggleDropdownPop(true)}>
            <div className="progress" style={{ background: 'radial-gradient(closest-side, #FCFCFC 79%, transparent 80% 100%), conic-gradient(#36BEC7 ' + userData?.profile_complate + '%, #FCFCFC 0)' }}></div>
            <div className="outline">
              <Avatar imgSrc={avtar?.cdn_path || DonorIcon} caption="User profile picture" />
            </div>
          </div>
          <div className="profile-v2 mob-hide" onClick={handleToggleDropdown}>
            <div className="progress" style={{ background: 'radial-gradient(closest-side, #FCFCFC 79%, transparent 80% 100%), conic-gradient(#36BEC7 ' + userData?.profile_complate + '%, #FCFCFC 0)' }}></div>
            <div className="outline">
              <Avatar imgSrc={avtar?.cdn_path || DonorIcon} caption="User profile picture" />
            </div>
          </div>
          {isDropDownOpen
            && window.innerWidth > 480 ? (
              <ul className="profile-dropdown-list py-2 bg-white">
                {full_name && (
                  <li className="cursor-poiner name text-bold">
                    {full_name}
                  </li>
                )}
                <li className="cursor-poiner dropdown-item" onClick={() => { handleRedirection('/editprofile', true); }}>
                  View Profile
                </li>
                <li className="cursor-poiner dropdown-item" onClick={() => { handleRedirection('/mydonations', true); }}>
                  My Donations
                </li>
                {wallet.length != 0 && (
                  <li className="cursor-poiner dropdown-item" onClick={() => { handleRedirection('/mywallet', true); }}>
                    My Wallet
                  </li>
                )}
                {isSubscribed && (
                  <li className="cursor-poiner dropdown-item" onClick={() => handleRedirection(latestOrder && latestOrder.status_flag != 1 ? '/inactiveuser' : '/', true)}>
                    My SIP Dashboard
                  </li>
                )}
                <li className="cursor-poiner dropdown-item" onClick={() => handleRedirection('/preferences', true)}>
                  My Preferences
                </li>
                <li className="cursor-poiner dropdown-item" onClick={() => handleLogout()}>
                  Logout
                </li>
              </ul>
            )
            : (
              <SwipeableTemporaryDrawer
                value={isDropDownOpen2}
                toggleDrawer={handleToggleDropdownPop}
                userData={userData}
                handleRedirection={handleRedirection}
                wallet={wallet} />
            )}
        </div>
      </div>
    </div>
  );
}

export default Navbar;
